import React from 'react';
import { testimonialData } from '../../data/distributorsData';
import { Quote, TrendingUp, DollarSign, Users } from 'lucide-react';

const TestimonialSection = () => {
  return (
    <section className="py-24 bg-[#e3e4e6]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 bg-[#1297fd]/10 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Caso de Éxito
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Cómo maximizamos{' '}
            <span className="text-[#1297fd]">eficiencia y crecimiento</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-2xl mx-auto">
            Empoderamos a distribuidores con un marketplace cloud sin fricciones que simplifica operaciones e impulsa expansión de negocio.
          </p>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl border border-[#e3e4e6] relative overflow-hidden">
            {/* Quote Icon */}
            <div className="absolute top-6 right-6 w-16 h-16 bg-[#8bcaf9]/20 rounded-2xl flex items-center justify-center">
              <Quote className="w-8 h-8 text-[#1297fd]" />
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 bg-[#1297fd]/5 rounded-2xl">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <DollarSign className="w-5 h-5 text-[#1297fd]" />
                  <span className="text-2xl sm:text-3xl font-bold text-[#1297fd]">70%</span>
                </div>
                <p className="text-[#c3c3c5] text-sm">Reducción de costes</p>
              </div>
              <div className="text-center p-4 bg-[#1297fd]/5 rounded-2xl">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <TrendingUp className="w-5 h-5 text-green-500" />
                  <span className="text-2xl sm:text-3xl font-bold text-green-500">25%</span>
                </div>
                <p className="text-[#c3c3c5] text-sm">Crecimiento clientes top</p>
              </div>
              <div className="text-center p-4 bg-[#1297fd]/5 rounded-2xl">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Users className="w-5 h-5 text-[#40aaf8]" />
                  <span className="text-2xl sm:text-3xl font-bold text-[#40aaf8]">100%</span>
                </div>
                <p className="text-[#c3c3c5] text-sm">Mejor experiencia</p>
              </div>
            </div>

            {/* Quote */}
            <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed mb-8 font-medium">
              "{testimonialData.quote}"
            </p>

            {/* Author */}
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                <span className="text-white text-2xl font-bold">{testimonialData.author.charAt(0)}</span>
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900">
                  {testimonialData.author}
                </h4>
                <p className="text-[#c3c3c5]">
                  {testimonialData.role}, {testimonialData.company}
                </p>
                <p className="text-[#1297fd] font-medium text-sm">
                  {testimonialData.location}
                </p>
              </div>
            </div>

            {/* Decorative */}
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#8bcaf9]/10 rounded-tr-full -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
